import React, { useState, useEffect } from 'react';
import { config } from './config';

// --- アイコンコンポーネント ---
const PlusIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>;
const EditIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg>;
const TrashIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg>;
const EyeIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z"></path><circle cx="12" cy="12" r="3"></circle></svg>;
const UserIcon = () => (<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" /></svg>);
const CalendarIcon = () => (<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="18" height="18" x="3" y="4" rx="2" ry="2" /><line x1="16" x2="16" y1="2" y2="6" /><line x1="8" x2="8" y1="2" y2="6" /><line x1="3" x2="21" y1="10" y2="10" /></svg>);
const CopyIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="14" height="14" x="8" y="8" rx="2" ry="2"></rect><path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"></path></svg>;

const api = {
  getFormConfig: async () => {
    const response = await fetch(`${config.api.invokeUrl}/form-config`);
    if (!response.ok) {
      if (response.status === 404) return { fields: [] };
      throw new Error('設定の取得に失敗しました。');
    }
    return await response.json();
  },
  saveFormConfig: async (fields) => {
    const response = await fetch(`${config.api.invokeUrl}/form-config`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ fields }),
    });
    if (!response.ok) throw new Error('設定の保存に失敗しました。');
    return await response.json();
  },
  createReport: async (reportData) => {
    const response = await fetch(`${config.api.invokeUrl}/reports`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(reportData),
    });
    if (!response.ok) throw new Error('日報の送信に失敗しました。');
    return await response.json();
  },
  getReports: async () => {
    const response = await fetch(`${config.api.invokeUrl}/reports`);
    if (!response.ok) throw new Error('日報一覧の取得に失敗しました。');
    return await response.json();
  },
  getReport: async (teamId, date) => {
    const response = await fetch(`${config.api.invokeUrl}/reports/${teamId}/${date}`);
    if (!response.ok) throw new Error('日報データの取得に失敗しました。');
    return await response.json();
  },
  updateReport: async (teamId, date, reportData) => {
    const response = await fetch(`${config.api.invokeUrl}/reports/${teamId}/${date}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(reportData),
    });
    if (!response.ok) throw new Error('日報の更新に失敗しました。');
    return await response.json();
  },
  deleteReport: async (teamId, date) => {
    const response = await fetch(`${config.api.invokeUrl}/reports/${teamId}/${date}`, {
      method: 'DELETE',
    });
    if (!response.ok) throw new Error('日報の削除に失敗しました。');
    return await response.json();
  }
};

// --- 共有コンポーネント ---
const Header = ({ title, children }) => (
  <header className="bg-white shadow-md sticky top-0 z-10">
    <div className="max-w-4xl mx-auto py-4 px-4 sm:px-6 lg:px-8 flex justify-between items-center">
      <h1 className="text-2xl font-bold text-gray-900">{title}</h1>
      <div>{children}</div>
    </div>
  </header>
);

// --- 項目編集モーダル ---
const ItemEditModal = ({ item, onSave, onCancel }) => {
  const [editedItem, setEditedItem] = useState(JSON.parse(JSON.stringify(item || { type: 'text', section: 'その他', requiredForSameDay: false, width: '100' })));
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setEditedItem(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
  };
  const handleOptionsChange = (e, targetList) => {
    const optionsArray = e.target.value.split(',').map(s => s.trim());
    if (targetList) {
      setEditedItem(prev => ({ ...prev, options: { ...(prev.options || {}), [targetList]: optionsArray } }));
    } else {
      setEditedItem(prev => ({ ...prev, options: optionsArray }));
    }
  }
  const handleSave = () => {
    const cleanedItem = JSON.parse(JSON.stringify(editedItem));
    if (cleanedItem.type === 'staff_selector' && cleanedItem.options) {
      if (cleanedItem.options.shain) cleanedItem.options.shain = cleanedItem.options.shain.filter(Boolean);
      if (cleanedItem.options.part) cleanedItem.options.part = cleanedItem.options.part.filter(Boolean);
    }
    if (['radio', 'select'].includes(cleanedItem.type) && Array.isArray(cleanedItem.options)) {
      cleanedItem.options = cleanedItem.options.filter(Boolean);
    }
    const itemToSave = { ...cleanedItem, id: cleanedItem.id || `custom_${Date.now()}` };
    onSave(itemToSave);
  };
  const isIdEditable = !item || (item && item.id && typeof item.id === 'string' && item.id.startsWith('custom_'));
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl p-6 w-full max-w-2xl space-y-4 max-h-full overflow-y-auto">
        <h2 className="text-xl font-bold text-gray-800">{item ? '項目の編集' : '新規項目の追加'}</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">項目ID (半角英数字)</label>
            <input name="id" value={editedItem.id || ''} onChange={handleChange} className={`mt-1 block w-full p-2 border border-gray-300 rounded-md ${!isIdEditable ? 'bg-gray-200 cursor-not-allowed' : ''}`} readOnly={!isIdEditable} />
            <p className="text-xs text-gray-500 mt-1">{isIdEditable ? "プログラムが使用する名前です。" : "このIDは変更できません。"}</p>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">ラベル (項目名)</label>
            <input name="label" value={editedItem.label || ''} onChange={handleChange} className="mt-1 block w-full p-2 border border-gray-300 rounded-md" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">入力タイプ</label>
            <select name="type" value={editedItem.type} onChange={handleChange} className="mt-1 block w-full p-2 border border-gray-300 rounded-md bg-white">
              <option value="text">テキスト (1行)</option>
              <option value="textarea">テキストエリア (複数行)</option>
              <option value="number">数値</option>
              <option value="date">日付</option>
              <option value="radio">ラジオボタン</option>
              <option value="select">セレクトボックス</option>
              <option value="staff_selector">場内員セレクター</option>
              <option value="divider">区切り線</option>
            </select>
          </div>
          {editedItem.type !== 'divider' && (
            <>
              <div>
                <label className="block text-sm font-medium text-gray-700">セクション</label>
                <input name="section" value={editedItem.section || ''} onChange={handleChange} className="mt-1 block w-full p-2 border border-gray-300 rounded-md" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">表示幅</label>
                <select name="width" value={editedItem.width || '100'} onChange={handleChange} className="mt-1 block w-full p-2 border border-gray-300 rounded-md bg-white">
                  <option value="100">100% (全体の幅)</option>
                  <option value="50">50% (半分の幅)</option>
                </select>
              </div>
            </>
          )}
        </div>
        {editedItem.type === 'number' && (<div><label className="block text-sm font-medium text-gray-700">単位 (例: kg, h)</label><input name="unit" value={editedItem.unit || ''} onChange={handleChange} className="mt-1 block w-full p-2 border border-gray-300 rounded-md" /></div>)}
        {['radio', 'select'].includes(editedItem.type) && (<div className="md:col-span-2"><label className="block text-sm font-medium text-gray-700">選択肢 (カンマ区切り)</label><input value={Array.isArray(editedItem.options) ? editedItem.options.join(', ') : ''} onChange={handleOptionsChange} className="mt-1 block w-full p-2 border border-gray-300 rounded-md" /></div>)}
        {editedItem.type === 'staff_selector' && (<div className="md:col-span-2 space-y-2"><div><label className="block text-sm font-medium text-gray-700">社員リスト (カンマ区切り)</label><textarea value={editedItem.options?.shain?.join(', ') || ''} onChange={(e) => handleOptionsChange(e, 'shain')} rows="2" className="mt-1 block w-full p-2 border border-gray-300 rounded-md" /></div><div><label className="block text-sm font-medium text-gray-700">パートリスト (カンマ区切り)</label><textarea value={editedItem.options?.part?.join(', ') || ''} onChange={(e) => handleOptionsChange(e, 'part')} rows="2" className="mt-1 block w-full p-2 border border-gray-300 rounded-md" /></div></div>)}
        {editedItem.type !== 'divider' && (<div><label className="flex items-center space-x-2"><input type="checkbox" name="requiredForSameDay" checked={editedItem.requiredForSameDay} onChange={handleChange} /><span>当日中の入力を必須にする</span></label></div>)}
        <div className="flex justify-end space-x-3 pt-4 border-t"><button onClick={onCancel} className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50">キャンセル</button><button onClick={handleSave} className="px-4 py-2 bg-blue-600 text-white font-semibold rounded-md shadow-sm hover:bg-blue-700">保存</button></div>
      </div>
    </div>
  );
};

// --- プレビューモーダル ---
const FormPreviewModal = ({ fields, onClose }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4">
      <div className="bg-gray-50 rounded-lg shadow-xl p-6 w-full max-w-3xl max-h-full overflow-y-auto">
        <h2 className="text-xl font-bold text-gray-800 mb-4">フォームプレビュー</h2>
        <div className="space-y-6">
          {fields.map(field => {
            if (field.type === 'divider') {
              return (
                <div key={field.id} className="flex items-center pt-2">
                  {field.label && <h4 className="text-gray-600 font-semibold pr-4 flex-shrink-0">{field.label}</h4>}
                  <div className="flex-grow border-t border-gray-300"></div>
                </div>
              );
            }
            return (
              <div key={field.id}>
                <label className="block text-sm font-medium text-gray-700">{field.label} {field.requiredForSameDay && <span className="text-red-500">*</span>}</label>
                <div className="mt-1 text-gray-600">
                  {field.type === 'text' && <input type="text" disabled className="w-full p-2 border bg-gray-200 rounded-md" placeholder={field.label} />}
                  {field.type === 'number' && <div className="flex items-center"><input type="number" disabled className="w-full p-2 border bg-gray-200 rounded-md" placeholder="0" /><span className="ml-2">{field.unit}</span></div>}
                  {field.type === 'textarea' && <textarea disabled rows="3" className="w-full p-2 border bg-gray-200 rounded-md" placeholder={field.label}></textarea>}
                  {field.type === 'date' && <input type="date" disabled className="p-2 border bg-gray-200 rounded-md" />}
                  {field.type === 'radio' && <div className="flex gap-x-4">{field.options.map(opt => <label key={opt}><input type="radio" disabled /> {opt}</label>)}</div>}
                  {field.type === 'select' && <select disabled className="w-full p-2 border bg-gray-200 rounded-md">{field.options.map(opt => <option key={opt}>{opt}</option>)}</select>}
                  {field.type === 'staff_selector' && <div className="p-2 border rounded-md bg-gray-200">場内員選択のUIが表示されます</div>}
                </div>
              </div>
            )
          })}
        </div>
        <div className="flex justify-end pt-4 mt-4 border-t">
          <button onClick={onClose} className="px-4 py-2 bg-gray-600 text-white font-semibold rounded-md shadow-sm hover:bg-gray-700">閉じる</button>
        </div>
      </div>
    </div>
  );
};

// --- 管理者画面コンポーネント ---
const AdminView = ({ setView }) => {
  const [fields, setFields] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadConfig = async () => {
      setIsLoading(true);
      setError(null);
      try {
        const data = await api.getFormConfig();
        setFields(data.fields);
      } catch (err) {
        console.error("設定の読み込みに失敗しました:", err);
        setError("設定の読み込みに失敗しました。AWS側の設定（特にCORS）を確認してください。");
      } finally {
        setIsLoading(false);
      }
    };
    loadConfig();
  }, []);

  const handleSaveAndApply = async () => {
    setIsLoading(true);
    setError(null);
    try {
      await api.saveFormConfig(fields);
      alert('設定が保存されました。');
    } catch (err) {
      console.error("設定の保存に失敗しました:", err);
      setError("設定の保存に失敗しました。");
    } finally {
      setIsLoading(false);
    }
  };

  const handleAddItem = () => { setEditingItem(null); setIsModalOpen(true); };
  const handleEditItem = (item) => { setEditingItem(item); setIsModalOpen(true); };
  const handleDeleteItem = (idToDelete) => { if (window.confirm('この項目を本当に削除しますか？')) setFields(fields.filter(f => f.id !== idToDelete)); };
  const handleSaveItem = (itemToSave) => {
    const index = fields.findIndex(f => f.id === itemToSave.id);
    if (index > -1) {
      const newFields = [...fields]; newFields[index] = itemToSave; setFields(newFields);
    } else {
      setFields([...fields, itemToSave]);
    }
    setIsModalOpen(false);
  };
  const moveItem = (index, direction) => {
    const newIndex = index + direction;
    if (newIndex < 0 || newIndex >= fields.length) return;
    const newFields = [...fields];
    const item = newFields.splice(index, 1)[0];
    newFields.splice(newIndex, 0, item);
    setFields(newFields);
  };

  if (isLoading) return <div className="p-8 text-center">設定を読み込んでいます...</div>;
  if (error) return <div className="p-8 text-center text-red-600 font-bold">{error}</div>;

  return (
    <div>
      <Header title="日報項目 管理画面">
        <div className="flex items-center space-x-3">
          <button onClick={() => setIsPreviewOpen(true)} className="flex items-center space-x-2 px-4 py-2 bg-green-600 text-white font-semibold rounded-md shadow-sm hover:bg-green-700"><EyeIcon /><span>プレビュー</span></button>
          <button onClick={handleAddItem} className="flex items-center space-x-2 px-4 py-2 bg-blue-600 text-white font-semibold rounded-md shadow-sm hover:bg-blue-700"><PlusIcon /><span>新規項目</span></button>
          <button onClick={handleSaveAndApply} className="px-4 py-2 bg-indigo-600 text-white font-semibold rounded-md shadow-sm hover:bg-indigo-700">保存</button>
        </div>
      </Header>
      <main className="max-w-4xl mx-auto py-6 sm:px-6 lg:px-8">
        <div className="bg-white rounded-lg shadow-lg overflow-hidden">
          <div className="p-4 text-sm text-gray-600 bg-yellow-50 border-b">
            <p>ここでは日報の入力項目をカスタマイズできます。「保存」ボタンを押すと、利用者画面に反映されます。</p>
          </div>
          <ul className="divide-y divide-gray-200">
            {fields.map((field, index) => (
              <li key={field.id} className="p-4 flex items-center justify-between hover:bg-gray-50">
                {field.type === 'divider' ? (
                  <div className="w-full flex items-center justify-between">
                    <div className="flex items-center space-x-4 flex-grow">
                      <div className="flex flex-col space-y-2 text-gray-500"><button onClick={() => moveItem(index, -1)} disabled={index === 0} className="disabled:opacity-20 hover:text-blue-600">▲</button><button onClick={() => moveItem(index, 1)} disabled={index === fields.length - 1} className="disabled:opacity-20 hover:text-blue-600">▼</button></div>
                      <div className="w-full flex items-center text-gray-500"><h4 className="text-gray-600 font-semibold pr-4 flex-shrink-0">{field.label || '区切り線'}</h4><div className="flex-grow border-t border-dashed border-gray-400"></div></div>
                    </div>
                    <div className="flex items-center space-x-3"><button onClick={() => handleEditItem(field)} className="p-2 text-gray-600 hover:text-blue-700 hover:bg-blue-100 rounded-full"><EditIcon /></button><button onClick={() => handleDeleteItem(field.id)} className="p-2 text-gray-600 hover:text-red-700 hover:bg-red-100 rounded-full"><TrashIcon /></button></div>
                  </div>
                ) : (
                  <>
                    <div className="flex items-center space-x-4">
                      <div className="flex flex-col space-y-2 text-gray-500"><button onClick={() => moveItem(index, -1)} disabled={index === 0} className="disabled:opacity-20 hover:text-blue-600">▲</button><button onClick={() => moveItem(index, 1)} disabled={index === fields.length - 1} className="disabled:opacity-20 hover:text-blue-600">▼</button></div>
                      <div>
                        <p className="text-lg font-semibold text-gray-800">{field.label}</p>
                        <div className="flex items-center flex-wrap gap-x-4 gap-y-1 text-sm text-gray-500 mt-1">
                          <span>ID: <span className="font-mono bg-gray-200 px-1.5 py-0.5 rounded">{field.id}</span></span>
                          <span>タイプ: <span className="font-mono bg-gray-200 px-1.5 py-0.5 rounded">{field.type}</span></span>
                          <span>幅: <span className="font-mono bg-gray-200 px-1.5 py-0.5 rounded">{field.width || '100'}%</span></span>
                          {field.requiredForSameDay && <span className="text-red-600 font-bold">当日必須</span>}
                        </div>
                      </div>
                    </div>
                    <div className="flex items-center space-x-3"><button onClick={() => handleEditItem(field)} className="p-2 text-gray-600 hover:text-blue-700 hover:bg-blue-100 rounded-full"><EditIcon /></button><button onClick={() => handleDeleteItem(field.id)} className="p-2 text-gray-600 hover:text-red-700 hover:bg-red-100 rounded-full"><TrashIcon /></button></div>
                  </>
                )}
              </li>
            ))}
          </ul>
        </div>
      </main>
      <div className="text-center my-8">
        <button onClick={() => setView('report_list')} className="text-blue-600 hover:underline font-semibold">日報一覧へ切り替え →</button>
      </div>
      {isModalOpen && <ItemEditModal item={editingItem} onSave={handleSaveItem} onCancel={() => setIsModalOpen(false)} />}
      {isPreviewOpen && <FormPreviewModal fields={fields} onClose={() => setIsPreviewOpen(false)} />}
    </div>
  );
};

// --- 動的フィールドコンポーネント ---
const DynamicField = ({ field, value, onChange }) => {
  const { id, label, type, placeholder, unit, options } = field;

  const handleChange = (e) => onChange(id, e.target.value);
  const handleStaffChange = (type, member) => {
    const currentStaff = value || { shain: { members: [] }, part: { members: [] } };
    const currentMembers = currentStaff[type].members;
    const newMembers = currentMembers.includes(member)
      ? currentMembers.filter(m => m !== member)
      : [...currentMembers, member];

    onChange(id, {
      ...currentStaff,
      [type]: { ...currentStaff[type], members: newMembers, count: newMembers.length }
    });
  };

  if (field.type === 'divider') {
    return (
      <div className="md:col-span-2">
        <div className="flex items-center pt-2">
          {field.label && <h4 className="text-gray-600 font-semibold pr-4 flex-shrink-0">{field.label}</h4>}
          <div className="flex-grow border-t border-gray-300"></div>
        </div>
      </div>
    );
  }

  const widthClass = field.width === '50' ? 'md:col-span-1' : 'md:col-span-2';

  return (
    <div className={widthClass}>
      <label htmlFor={id} className="block text-sm font-medium text-gray-700">{label} {field.requiredForSameDay && <span className="text-red-500">*</span>}</label>
      <div className="mt-1">
        {(() => {
          switch (type) {
            case 'date':
              return <div className="relative"><input type="date" id={id} value={value || ''} onChange={handleChange} className="w-full p-2 border border-gray-300 rounded-md shadow-sm" /><div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none"><CalendarIcon /></div></div>;
            case 'text':
              return <input type="text" id={id} value={value || ''} onChange={handleChange} placeholder={placeholder} className="w-full p-2 border border-gray-300 rounded-md shadow-sm" />;
            case 'number':
              return <div className="flex items-center"><input type="number" id={id} value={value || ''} onChange={handleChange} placeholder={placeholder} className="flex-grow p-2 border border-gray-300 rounded-md shadow-sm" /><span className="ml-2 text-gray-600">{unit}</span></div>;
            case 'textarea':
              return <textarea id={id} value={value || ''} onChange={handleChange} placeholder={placeholder} rows={3} className="w-full p-2 border border-gray-300 rounded-md shadow-sm" />;
            case 'radio':
              return <div className="flex flex-wrap gap-x-4 gap-y-2 pt-2">{options.map(opt => <label key={opt} className="flex items-center space-x-2"><input type="radio" name={id} value={opt} checked={value === opt} onChange={handleChange} /><span>{opt}</span></label>)}</div>;
            case 'select':
              return <select id={id} value={value || ''} onChange={handleChange} className="w-full p-2 border border-gray-300 rounded-md shadow-sm bg-white">{options.map(opt => <option key={opt} value={opt}>{opt}</option>)}</select>;
            case 'staff_selector':
              const staffValue = value || { shain: { count: 0, members: [] }, part: { count: 0, members: [] } };
              return (
                <div className="flex flex-col space-y-4 p-4 border rounded-md">
                  <div>
                    <p className="font-semibold text-sm text-gray-600">社員 ({staffValue.shain.count || 0}名)</p>
                    <div className="flex flex-wrap gap-x-4 gap-y-2 mt-2">
                      {options.shain.map(name => (
                        <label key={name} className="flex items-center space-x-2">
                          <input type="checkbox" checked={staffValue.shain.members.includes(name)} onChange={() => handleStaffChange('shain', name)} />
                          <span>{name}</span>
                        </label>
                      ))}
                    </div>
                  </div>
                  <div>
                    <p className="font-semibold text-sm text-gray-600">パート ({staffValue.part.count || 0}名)</p>
                    <div className="flex flex-wrap gap-x-4 gap-y-2 mt-2">
                      {options.part.map(name => (
                        <label key={name} className="flex items-center space-x-2">
                          <input type="checkbox" checked={staffValue.part.members.includes(name)} onChange={() => handleStaffChange('part', name)} />
                          <span>{name}</span>
                        </label>
                      ))}
                    </div>
                  </div>
                </div>
              );
            default:
              return <div>Unsupported field type: {type}</div>;
          }
        })()}
      </div>
    </div>
  );
};

// --- 日報一覧画面コンポーネント ---
const ReportListView = ({ setView, onEditReport }) => {
  const [reports, setReports] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [openSections, setOpenSections] = useState({});

  const groupReports = (data) => {
    return data.reduce((acc, report) => {
      const date = new Date(report['日付']);
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      if (!acc[year]) acc[year] = {};
      if (!acc[year][month]) acc[year][month] = [];
      acc[year][month].push(report);
      return acc;
    }, {});
  };

  const fetchReports = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const data = await api.getReports();
      data.sort((a, b) => new Date(b['日付']) - new Date(a['日付']));
      setReports(groupReports(data));
    } catch (err) {
      setError("日報一覧の取得に失敗しました。");
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchReports();
  }, []);

  const handleDelete = async (teamId, date) => {
    if (window.confirm(`${date}の日報を本当に削除しますか？`)) {
      try {
        await api.deleteReport(teamId, date);
        fetchReports();
      } catch (err) {
        alert(`削除に失敗しました。\n\n詳細: ${err.message}`);
        console.error(err);
      }
    }
  };

  const toggleSection = (key) => {
    setOpenSections(prev => ({ ...prev, [key]: !prev[key] }));
  };

  if (isLoading) return <div className="p-8 text-center">日報一覧を読み込んでいます...</div>;
  if (error) return <div className="p-8 text-center text-red-600 font-bold">{error}</div>;

  return (
    <div>
      <Header title="日報一覧">
        <div className="flex items-center space-x-3">
          <button onClick={() => setView('admin')} className="text-gray-600 hover:underline">管理者画面へ</button>
          <button onClick={() => setView('user_create')} className="flex items-center space-x-2 px-4 py-2 bg-blue-600 text-white font-semibold rounded-md shadow-sm hover:bg-blue-700"><PlusIcon /><span>新規作成</span></button>
        </div>
      </Header>
      <main className="max-w-4xl mx-auto py-6 sm:px-6 lg:px-8">
        <div className="bg-white rounded-lg shadow-lg overflow-hidden">
          {Object.keys(reports).length === 0 ? (
            <div className="p-4 text-center text-gray-500">登録された日報はありません。</div>
          ) : (
            Object.keys(reports).sort((a, b) => b - a).map(year => (
              <div key={year}>
                <div onClick={() => toggleSection(year)} className="bg-gray-100 p-3 flex justify-between items-center cursor-pointer border-b border-t hover:bg-gray-200">
                  <h2 className="text-lg font-bold text-gray-700">{year}年</h2>
                  <span className="transform transition-transform duration-200">{openSections[year] ? '▼' : '▶'}</span>
                </div>
                {openSections[year] && (
                  Object.keys(reports[year]).sort((a, b) => b - a).map(month => (
                    <div key={`${year}-${month}`} className="pl-4 border-l-2 border-gray-200">
                      <div onClick={() => toggleSection(`${year}-${month}`)} className="p-2 flex justify-between items-center cursor-pointer hover:bg-gray-50">
                        <h3 className="text-md font-semibold text-gray-600">{month}月</h3>
                        <span className="transform transition-transform duration-200">{openSections[`${year}-${month}`] ? '▼' : '▶'}</span>
                      </div>
                      {openSections[`${year}-${month}`] && (
                        <ul className="divide-y divide-gray-200 pl-4">
                          {reports[year][month].map(report => (
                            <li key={report['チームID']} className="p-4 flex flex-col sm:flex-row items-start sm:items-center justify-between hover:bg-gray-50">
                              <div className="mb-2 sm:mb-0">
                                <p className="text-lg font-semibold text-gray-800">{report['日付']}</p>
                                <p className="text-xs text-gray-500 mt-1">チームID: <span className="font-mono">{report['チームID']}</span></p>
                                <a href={report.htmlUrl} target="_blank" rel="noopener noreferrer" className="text-xs text-blue-600 hover:underline break-all">{report.htmlUrl}</a>
                              </div>
                              <div className="flex items-center space-x-2 flex-shrink-0">
                                <button onClick={() => onEditReport(report['チームID'], report['日付'])} className="p-2 text-gray-600 hover:text-blue-700 hover:bg-blue-100 rounded-full"><EditIcon /></button>
                                <button onClick={() => handleDelete(report['チームID'], report['日付'])} className="p-2 text-gray-600 hover:text-red-700 hover:bg-red-100 rounded-full"><TrashIcon /></button>
                              </div>
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  ))
                )}
              </div>
            ))
          )}
        </div>
      </main>
    </div>
  );
};

// --- 利用者画面コンポーネント ---
const UserView = ({ setView, reportToEdit }) => {
  const [formConfig, setFormConfig] = useState([]);
  const [formData, setFormData] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [lastReportUrl, setLastReportUrl] = useState(null);

  const isEditMode = !!reportToEdit;

  useEffect(() => {
    const loadData = async () => {
      setIsLoading(true);
      setError(null);
      try {
        const configData = await api.getFormConfig();
        setFormConfig(configData.fields);

        if (isEditMode) {
          const reportData = await api.getReport(reportToEdit.teamId, reportToEdit.date);
          setFormData(reportData);
        } else {
          const initialData = {};
          configData.fields.forEach(field => {
            if (field.type === 'date') initialData[field.id] = new Date().toISOString().slice(0, 10);
            else if (field.type === 'radio') initialData[field.id] = field.options?.[0];
          });
          setFormData(initialData);
        }
      } catch (err) {
        console.error("データの読み込みに失敗しました:", err);
        setError("データの読み込みに失敗しました。");
      } finally {
        setIsLoading(false);
      }
    };
    loadData();
  }, [reportToEdit, isEditMode]);

  const handleInputChange = (id, value) => {
    setFormData(prev => ({ ...prev, [id]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLastReportUrl(null);
    try {
      let result;
      if (isEditMode) {
        result = await api.updateReport(reportToEdit.teamId, reportToEdit.date, formData);
        alert(`日報を更新しました。`);
      } else {
        result = await api.createReport(formData);
        alert(`日報を送信しました。\n生成されたURLは画面下部に表示されます。`);
      }
      setLastReportUrl(result.url);
    } catch (error) {
      alert(`エラーが発生しました。\n\n詳細: ${error.message}`);
      console.error(error);
    }
  };

  const copyToClipboard = (text) => {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
      document.execCommand('copy');
      alert('URLをクリップボードにコピーしました！');
    } catch (err) {
      alert('コピーに失敗しました。');
    }
    document.body.removeChild(textArea);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && e.target.tagName !== 'TEXTAREA') {
      e.preventDefault();
    }
  };

  if (isLoading) return <div className="p-8 text-center">フォームを読み込んでいます...</div>;
  if (error) return <div className="p-8 text-center text-red-600 font-bold">{error}</div>;

  return (
    <div>
      <Header title={isEditMode ? "日報の編集" : "関東支店 作業日報"} />
      <main className="max-w-4xl mx-auto py-6 sm:px-6 lg:px-8">
        <form onSubmit={handleSubmit} onKeyDown={handleKeyDown} className="bg-white p-6 sm:p-8 rounded-lg shadow-lg">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {formConfig.map(field => (
              <DynamicField key={field.id} field={field} value={formData[field.id]} onChange={handleInputChange} />
            ))}
          </div>
          <div className="flex justify-between items-center pt-8 mt-8 border-t">
            <button type="button" onClick={() => setView('report_list')} className="text-gray-600 hover:underline">← 一覧へ戻る</button>
            <button type="submit" className="px-6 py-2 bg-blue-600 text-white font-semibold rounded-md shadow-sm hover:bg-blue-700">{isEditMode ? "更新する" : "日報を送信"}</button>
          </div>
        </form>
        {lastReportUrl && (
          <div className="mt-8 p-4 bg-green-50 border border-green-200 rounded-lg shadow-sm">
            <h3 className="font-semibold text-lg text-green-800">処理が完了しました</h3>
            <p className="mt-2 text-sm text-gray-700">共有用のURLが生成されました。</p>
            <div className="mt-3 flex items-center">
              <input type="text" readOnly value={lastReportUrl} className="w-full p-2 border border-gray-300 rounded-md bg-gray-100 text-gray-600" />
              <button type="button" onClick={() => copyToClipboard(lastReportUrl)} className="ml-2 px-3 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 flex items-center space-x-2 flex-shrink-0"><CopyIcon /><span>コピー</span></button>
            </div>
          </div>
        )}
      </main>
    </div>
  );
};

// --- メインのAppコンポーネント ---
export default function App() {
  const [view, setView] = useState('report_list');
  const [reportToEdit, setReportToEdit] = useState(null);

  const handleEditReport = (teamId, date) => {
    setReportToEdit({ teamId, date });
    setView('user_edit');
  };

  const renderView = () => {
    switch (view) {
      case 'admin':
        return <AdminView setView={setView} />;
      case 'user_create':
        return <UserView setView={setView} reportToEdit={null} />;
      case 'user_edit':
        return <UserView setView={setView} reportToEdit={reportToEdit} />;
      case 'report_list':
      default:
        return <ReportListView setView={setView} onEditReport={handleEditReport} />;
    }
  };

  return (
    <div className="bg-gray-100 min-h-screen font-sans">
      {renderView()}
    </div>
  );
}
